export default __webpack_public_path__ + "static/media/event-8.3c738ccb.jpg";